<div class="body" [formGroup]="formGroup">

    <div>

        <mat-form-field class="initials" [appearance]="appearance">
            <mat-label class="label">Initialen</mat-label>
            <input formControlName="initials" matInput placeholder="1-3 Zeichen" [readonly]="!editMode" />
        </mat-form-field>
    
        <mat-form-field class="width" [appearance]="appearance">
            <mat-label class="label">Benutzername</mat-label>
            <input formControlName="userName" matInput placeholder="Keine Leerzeichen, keine Sonderzeichen" [readonly]="!editMode" />
        </mat-form-field>

    </div>

    <div class="e-mail-wrapper">

        <mat-form-field class="width" [appearance]="appearance">
            <mat-label class="label">E-Mail Adresse</mat-label>
            <input formControlName="email" matInput placeholder="Ihre E-Mail Adresse" [readonly]="!editMode" />
        </mat-form-field>

    </div>

    <div>

        <button mat-raised-button color="primary" (click)="changePassword()">

            Passwort ändern

        </button>

    </div>

</div>
